import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { api, EmptyState, Loading, PageBanner, useShell } from "@tc/ui";
let cached = null;
export const fuelFeatures = () => (cached ??= api("/api/m/fuel/features").then((r) => r.features, () => ({})));
/** Forget the switches (after Fuel settings changes them). */
export const forgetFuelFeatures = () => { cached = null; };
/** The page isn't for this person: said plainly, with nothing loaded behind it. */
export function NoAccess({ title }) {
    return (_jsxs(_Fragment, { children: [_jsx(PageBanner, { title: title }), _jsx("div", { className: "tc-content", children: _jsx(EmptyState, { title: "You don't have access to this page", icon: "lock", children: "Ask head office if you need it." }) })] }));
}
const NAME = { pricing: "Price changes", checks: "Price checks", fuel_finder: "The Fuel Finder page", margins: "Margins", future: "Future prices" };
export function gated(key, Page, permission) {
    return function Gated(props) {
        const { can, navigate } = useShell();
        const [on, setOn] = useState(null);
        useEffect(() => { void fuelFeatures().then((f) => setOn(f[key] !== false)); }, []);
        // Opened by its address without the permission (overnight audit 26/10/26): the no-access card, not a half-drawn
        // page throwing "You don't have access to this." from every call.
        if (permission && !can(permission))
            return _jsx(NoAccess, { title: NAME[key] });
        if (on === null)
            return _jsx(Loading, {});
        if (on)
            return _jsx(Page, { ...props });
        return (_jsxs(_Fragment, { children: [_jsx(PageBanner, { title: NAME[key] }), _jsx("div", { className: "tc-content", children: _jsx(EmptyState, { title: `${NAME[key]} ${key === "fuel_finder" ? "is" : "are"} switched off`, children: can("fuel.settings") ? _jsxs(_Fragment, { children: ["Switch ", NAME[key].toLowerCase(), " back on in ", _jsx("a", { className: "tc-link", href: "/fuel/settings#features", onClick: (e) => { e.preventDefault(); navigate("/fuel/settings#features"); }, children: "Fuel settings \u2192 Features" }), "."] }) : "Head office can switch it back on in Fuel settings." }) })] }));
    };
}
